import React from 'react';
import BaseInfo from '../../screens/SignUp/components/BaseInfo';
import CustomerInfo from '../../screens/SignUp/components/CustomerInfo';
import DeliveryInfo from '../../screens/SignUp/components/DeliveryInfo';
import PaymentInfo from '../../screens/SignUp/components/PaymentInfo';
import Summary from '../../screens/SignUp/components/Summary';
import i18n from '../../i18n';

let steps = [{
    name: 'base-info',
    label: i18n.t('form.steps.orgNr'),
    component: <BaseInfo />
  },
  {
    name: 'customer-info',
    label: i18n.t('form.steps.customerInfo'),
    component: <CustomerInfo />
  },
  {
    name: 'delivery-info',
    label: i18n.t('form.steps.deliveryInfo'),
    component: <DeliveryInfo />
  },
  {
    name: 'payment-info',
    label: i18n.t('form.steps.paymentInfo'),
    component: <PaymentInfo />
  },
  {
    name: 'summary',
    label: i18n.t('form.steps.summary'),
    component: <Summary />
  }
];

export default steps;